module.exports = __webpack_public_path__ + "static/media/mobile-640.b4b9568f.png";